import * as actions from './actions'
import mutations from './mutations'

const state = () => ({
   items: [],
   itemsRef: [],
   itemsAtv: [],
   itemsAtvDtl: [],
   atividadeTipo: [],
   atividadePorId: null,
   patio: [],
   escala: {},
   funcionarioFiltros: null,

   incluirAtividade: {},
   editarAtividade: {},
   desconsiderarAtividade: {},

   paginaAtual: null,
   totalDePaginas: null,
   registrosPorPagina: null,
   totalDeRegistros: null,
   possuiPaginaAnterior: null,
   possuiProximaPagina: null,
   codigo: null,
   sucesso: null,
   mensagens: [],

   paginaAtualRef: null,
   totalDePaginasRef: null,
   registrosPorPaginaRef: null,
   totalDeRegistrosRef: null,
   possuiPaginaAnteriorRef: null,
   possuiProximaPaginaRef: null,
   codigoRef: null,
   sucessoRef: null,
   mensagensRef: [],

   paginaAtualAtv: null,
   totalDePaginasAtv: null,
   registrosPorPaginaAtv: null,
   totalDeRegistrosAtv: null,
   possuiPaginaAnteriorAtv: null,
   possuiProximaPaginaAtv: null,
   codigoAtv: null,
   sucessoAtv: null,
   mensagensAtv: [],

   paginaAtualAtvDtl: null,
   totalDePaginasAtvDtl: null,
   registrosPorPaginaAtvDtl: null,
   totalDeRegistrosAtvDtl: null,
   possuiPaginaAnteriorAtvDtl: null,
   possuiProximaPaginaAtvDtl: null,
   codigoAtvDtl: null,
   sucessoAtvDtl: null,
   mensagensAtvDtl: [],

   paginaAtualTipo: null,
   totalDePaginasTipo: null,
   registrosPorPaginaTipo: null,
   totalDeRegistrosTipo: null,
   possuiPaginaAnteriorTipo: null,
   possuiProximaPaginaTipo: null,
   codigoTipo: null,
   sucessoTipo: null,
   mensagensTipo: []
})

const gestaoPerido = {
   namespaced: true,
   state,
   actions,
   mutations
}

export default {
   gestaoPerido
}
